export default "__VITE_ASSET__CzNqHsiI__"